<div *ngIf="!isMobileApp">
  <div class="row m-0">
    <!-- Left Side (Image) -->
    <img src="assets/img/login.png" alt="Soccer Player" class="col-md-6 p-0" />

    <!-- Right Side (Login Form) -->
    <div class="col-12 col-md-6 d-flex align-items-center justify-content-center bg-black text-white">
      <div class="text-center p-4" style="max-width: 350px; width: 100%">
        <h2 class="fw-bold text-lime">Login Wemble</h2>

        <form>
          <div class="text-start mt-4">
            <label for="email" class="form-label">Email</label>
            <input id="email" type="email" class="form-control" placeholder="Email" />
          </div>

          <div class="text-start mt-3">
            <label for="password" class="form-label">Password</label>
            <div class="input-group">
              <input id="password" type="password" class="form-control password-input" placeholder="Password" />
              <span class="input-group-text"><i class="bi bi-eye"></i></span>
            </div>
          </div>

          <button type="submit" class="btn btn-lime w-100 mt-4">LOGIN</button>
        </form>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isMobileApp" class="mobile-login">
  <div class="ml-status-spacer"></div>

  <button type="button" class="ml-back-btn" (click)="navigateBack()">
    <i class="bi bi-arrow-left"></i>
  </button>

  <h1>{{ 'LOGIN.TITLE' | translate }}</h1>
  <p class="subtitle">{{ 'LOGIN.SUBTITLE' | translate }}</p>

  <div class="ml-field">
    <label for="ml-email">{{ 'LOGIN.EMAIL_LABEL' | translate }}</label>
    <div class="ml-input-wrap">
      <input id="ml-email" class="ml-input" type="email" [(ngModel)]="emailValue"
        [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate" />
      <button *ngIf="emailValue" type="button" class="ml-clear-btn" (click)="clearEmail()">x</button>
    </div>
    <span *ngIf="emailError" class="ml-error">{{ emailError | translate }}</span>
  </div>

  <div class="ml-field">
    <label for="ml-password">{{ 'LOGIN.PASSWORD_LABEL' | translate }}</label>
    <div class="ml-input-wrap">
      <input id="ml-password" class="ml-input" [type]="showPassword ? 'text' : 'password'" [(ngModel)]="passwordValue"
        placeholder="*************" />
      <button type="button" class="ml-eye-btn" (click)="togglePasswordVisibility()">
        <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
      </button>
    </div>
    <span *ngIf="passwordError" class="ml-error">{{ passwordError | translate }}</span>
  </div>

  <p>
    <span class="ml-forgot-link" (click)="navigateToForgotPassword()">
      {{ 'FORGOT_PASSWORD.FORGOT_HINT' | translate }}
    </span>
  </p>

  <p *ngIf="loginError" class="ml-login-error">{{ loginError | translate }}</p>

  <button type="button" class="ml-login-btn" (click)="validateAndSubmit()" [disabled]="isLoading">
    <span *ngIf="!isLoading">{{ 'LOGIN.LOG_IN_BTN' | translate }}</span>
    <i *ngIf="isLoading" class="bi bi-arrow-repeat spinner"></i>
  </button>

  <div class="ml-divider">
    <span class="line"></span>
    <span>{{ 'LOGIN.OR_LOGIN_WITH' | translate }}</span>
    <span class="line"></span>
  </div>

  <button type="button" class="social-btn google-btn" disabled>
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107"
        d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C34.1 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
      <path fill="#FF3D00"
        d="M6.3 14.7l6.6 4.8C14.7 15.9 19 12 24 12c3 0 5.7 1.1 7.8 2.9l5.7-5.7C34.1 6.1 29.3 4 24 4 16.3 4 9.6 8.3 6.3 14.7z" />
      <path fill="#4CAF50"
        d="M24 44c5.2 0 10-2 13.6-5.2l-6.3-5.3c-2 1.5-4.5 2.5-7.3 2.5-5.2 0-9.7-3.3-11.2-8l-6.5 5C9.5 39.6 16.2 44 24 44z" />
      <path fill="#1976D2"
        d="M43.6 20.5H42V20H24v8h11.3c-1.1 3.1-3.4 5.5-6.6 6.8l.1.1 6.3 5.3c-.5.4 8.9-6.2 8.9-16.2 0-1.3-.1-2.4-.4-3.5z" />
    </svg>
    <span>{{ 'LOGIN.CONTINUE_GOOGLE' | translate }}</span>
  </button>

  <button type="button" class="social-btn apple-btn" disabled>
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor"
        d="M16.37 1.43c0 1.14-.41 2.2-1.11 2.96-.78.84-2.06 1.49-3.16 1.4-.14-1.08.42-2.2 1.12-2.92.77-.81 2.1-1.41 3.15-1.44zM20.9 17.23c-.58 1.32-.86 1.9-1.6 3.07-1.04 1.64-2.51 3.69-4.33 3.7-1.62.01-2.03-1.06-4.24-1.04-2.21.01-2.67 1.06-4.29 1.04-1.82-.01-3.21-1.86-4.25-3.49-2.9-4.54-3.2-9.87-1.41-12.6 1.28-1.95 3.3-3.09 5.2-3.09 1.94 0 3.16 1.06 4.76 1.06 1.55 0 2.5-1.06 4.74-1.06 1.69 0 3.49.92 4.77 2.51-4.17 2.33-3.49 8.36.65 9.9z" />
    </svg>
    <span>{{ 'LOGIN.CONTINUE_APPLE' | translate }}</span>
  </button>

  <p class="ml-footer">
    {{ 'LOGIN.NO_ACCOUNT' | translate }}
    <span class="signup-link" (click)="navigateToRegister()">{{ 'LOGIN.SIGN_UP' | translate }}</span>
  </p>
</div>